const mobile = {
  boxSizing: "border-box",
  borderRadius: "4px",

  display: "inline-block",
  margin: "0 0 32px",
  position: "absolute",
  top: "24px",
  left: "24px",
};
const desktop = {
  boxSizing: "border-box",
  borderRadius: "4px",

  position: "absolute",
  top: "24px",
  left: "24px",
};

export default {
  divStyle: window.innerWidth > 899 ? desktop : mobile,
};
